import { distanceInWords, parseDateTime } from 'src/utils/date'
import { date } from 'quasar'
import { formatMoney } from 'src/utils/format'
import { getCustomerName } from 'src/utils/searchResultParser'
import { getStatusText } from 'components/Invoices/Utils'
import i18n from 'src/i18n/i18n'
import { quotes as quotesConfig } from 'src/config'

const defaultColumns = [
  { name: 'quote_number', required: true, label: i18n.t('quote_number'), align: 'left', field: 'quote_number', sortable: true },
  { name: 'customer_name', required: true, label: i18n.tc('customer', 1), align: 'left', field: 'customer_name' },
  { name: 'total_gross', required: true, label: i18n.t('sum_gross'), align: 'left', field: 'total_gross' },
  { name: 'created_at', required: true, label: i18n.t('created_at'), align: 'left', field: 'created_at_text', sortable: true },
  { name: 'status', required: true, label: i18n.t('status'), align: 'left', field: 'status' },
  { name: 'valid_until', required: true, label: i18n.t('valid_until'), align: 'left', field: 'valid_until' },
  { name: 'actions', required: false, label: '', align: 'right', field: 'invoice_number' }
]

const defaultMapFunction = quotes => {
  return quotes.map(quote => {
    return {
      ...quote,
      'customer_name': getCustomerName(quote.customer.data),
      'total_gross': formatMoney(quote.total_gross, quote.currency),
      'valid_until': date.formatDate(parseDateTime(quote.valid_until.date), i18n.t('date_format')),
      'status': { value: quote.status, color: quotesConfig.status_colors[quote.status] },
      'due_in': getStatusText(quote),
      'created_at_text': distanceInWords(quote.created_at.date),
      'created_at_date': date.formatDate(parseDateTime(quote.created_at.date), i18n.t('date_time_format'))
    }
  })
}

export { defaultMapFunction, defaultColumns }
